// Route to permission mappings - extracted from NavList component
export const routePermissions: { [key: string]: string } = {
  '/branch-overview': 'view-branch-overview',
  '/supplier/new': 'create-supplier',
  '/supplier/list': 'view-supplier-list',
  '/supplier/outstanding': 'view-supplier-outstanding',
  '/supplier/payment': 'view-supplier-settlement',
  '/supplier/cheque-payment': 'view-supplier-cheque-payment',
  '/inventory/category/list': 'view-category-list',
  '/inventory/brand/list': 'view-brand-list',
  '/inventory/main-product/list': 'view-main-product-list',
  '/inventory/sub-product/list': 'view-sub-product-list',
  '/inventory/add': 'view-add-stock',
  '/inventory/variance': 'view-purchase-history',
  '/inventory/availability': 'view-stock-availability',
  '/inventory/value': 'view-stock-value',
  '/inventory/invoice': 'view-stock-invoice',
  '/inventory/stock-quantity': 'view-stock-quantity',
  '/sales/receipt/create': 'view-create-receipt',
  '/sales/receipt/list': 'view-receipt-list',
  '/sales/exchange/list': 'view-exchange-receipt-list',
  '/sales/report': 'view-sales-report',
  '/sales/test-report': 'view-sales-report',
  '/sales/target': 'view-sales-target',
  '/sales/export': 'view-hcm-sales-export',
  '/sales/ogff-export': 'view-ogff-sales-export',
  '/customer/create': 'create-customer',
  '/customer/list': 'view-customer-list'
  // Security routes are handled by role-based access control (Admin role)
}; 